// extracted by mini-css-extract-plugin
export default {"section":"Payment_section__mmTIE","actions":"Payment_actions__sZCB4","line":"Payment_line__lIKFV","alert":"Payment_alert__ft0Fb"};